import { GraduationCap } from "lucide-react";
import {
  TeacherCardBox,
  TeacherImageBox,
  TeacherInfo,
  TeacherInitials,
  TeacherName,
  TeacherRoleRow,
  TeacherRoleText
} from "./LearningActivity.styles";

type ITeacherCard = {
  image?: string
  name: string
  role: string
}

export const TeacherCard = ({ image, name, role }: ITeacherCard) => {
  const initials = name
    ?.split(" ")
    .map(part => part.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <TeacherCardBox tabIndex={ -1 } aria-hidden="true" >
      <TeacherImageBox >
        { image ? (
          <img src={ image } alt="" loading="lazy" />
        ) : (
          <TeacherInitials>{ initials }</TeacherInitials>
        ) }
      </TeacherImageBox>
      <TeacherInfo>
        <TeacherName>{ name }</TeacherName>
        <TeacherRoleRow>
          <GraduationCap size="0.875rem" aria-hidden="true" />
          <TeacherRoleText>{ role }</TeacherRoleText>
        </TeacherRoleRow>
      </TeacherInfo>
    </TeacherCardBox>
  );
};
